import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CitationEdit } from '@/module/Author/Citation/CitationEdit';
import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { citationId, abstractId } = Route.useParams();
  const { data: citation } = useSuspenseQuery(getCitationOptions(abstractId, citationId));

  return (
    <CitationEdit
      citation={citation}
      publicationId={Number(abstractId)}
    />
  );
}
